/**
 * © 2026 Madar.iq — All Rights Reserved.
 * Domain License Validator - يُستخدم فقط في بيئة الإنتاج
 */

const ALLOWED_DOMAINS = [
  "madar.iq",
  "www.madar.iq",
  "app.madar.iq",
  "admin.madar.iq",
  "store.madar.iq",
  "localhost",       // للتطوير المحلي
  "127.0.0.1",
];

export function validateDomainLicense() {
  const hostname = window.location.hostname;

  // السماح دائماً في بيئة التطوير
  if (
    process.env.NODE_ENV === "development" ||
    hostname === "localhost" ||
    hostname === "127.0.0.1"
  ) {
    return true;
  }

  const isAllowed = ALLOWED_DOMAINS.some(
    (domain) => hostname === domain || hostname.endsWith("." + domain)
  );

  // إضافي: السماح بالدومينات التي تحتوي على "بصمة" مدار (يمكنك تفعيل هذا لاحقاً للدومينات الخاصة)
  const hasDigitalSignature = document.querySelector('meta[name="platform-provider"]')?.content === "Madar.iq";
  
  if (!isAllowed && !hasDigitalSignature) {
    // تسجيل محاولة الوصول غير المصرح
    console.error(
      `[Madar.iq] Unauthorized domain detected: ${hostname}. This software is licensed for use only on authorized domains.`
    );

    // رسم شاشة الحجب
    setTimeout(() => {
      document.body.innerHTML = `
        <div style="
          position:fixed;top:0;left:0;right:0;bottom:0;
          display:flex;flex-direction:column;
          align-items:center;justify-content:center;
          background:linear-gradient(135deg,#0f172a 0%,#1e1b4b 100%);
          color:#f8fafc;font-family:'Segoe UI',sans-serif;
          text-align:center;z-index:99999;gap:20px;padding:40px;
        ">
          <div style="font-size:80px;animation:pulse 2s infinite;">🔒</div>
          <h1 style="font-size:2.5rem;font-weight:800;
              background:linear-gradient(90deg,#ef4444,#f97316);
              -webkit-background-clip:text;-webkit-text-fill-color:transparent;">
            غير مرخص
          </h1>
          <div style="
            background:rgba(239,68,68,0.1);border:1px solid rgba(239,68,68,0.3);
            border-radius:12px;padding:24px 32px;max-width:500px;
          ">
            <p style="font-size:1.1rem;line-height:1.8;color:#cbd5e1;margin:0;">
              هذا البرنامج مرخص حصرياً لـ <strong style="color:#f1f5f9;">Madar.iq</strong><br/>
              ويعمل فقط على النطاقات المعتمدة.<br/><br/>
              <span style="color:#ef4444;font-weight:600;">
                تحذير: استخدامك غير المصرح به يُعرّضك للمساءلة القانونية.
              </span>
            </p>
          </div>
          <p style="color:#475569;font-size:0.9rem;">
            © 2026 Madar.iq — جميع الحقوق محفوظة
          </p>
        </div>
        <style>
          @keyframes pulse {
            0%,100%{transform:scale(1)}
            50%{transform:scale(1.1)}
          }
        </style>
      `;
    }, 0);

    return false;
  }

  return true;
}

export function getLicenseInfo() {
  return {
    product: "Madar.iq Admin Dashboard",
    version: "2.0.0",
    license: "PROPRIETARY — All Rights Reserved",
    copyright: "© 2026 Madar.iq",
    website: "https://madar.iq",
    notice:
      "This software and its source code are proprietary and confidential. " +
      "Unauthorized reproduction, distribution, or modification is strictly prohibited.",
  };
}
